import { render, staticRenderFns } from "./CvlibPackForm.vue?vue&type=template&id=2de585d3&"
import script from "./CvlibPackForm.vue?vue&type=script&lang=js&"
export * from "./CvlibPackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports